import React from "react";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
} from "react-share";

import {Link} from "react-scroll"

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="d-flex">
            <p>Quezaltepeque - La Libertad - El Salvador</p>
            </div>
            <div className="d-flex">
              <a href="tel:+50375511863">(+503) 75511863</a>
            </div>
            <div className="d-flex">
              <p className="correo"><a href="mailto:rafaelvady.q@gmail.com">rafaelvady.q@gmail.com</a></p>
            </div>
          </div>
          <div className="col-lg-3 col-md-2 col-sm-6">
            <div className="row">
              <div className="col">
                <Link smooth={true} to="home" offset={-100} className="footer-nav">Inicio</Link>
                <br />
                <Link smooth={true} to="about" offset={-100} className="footer-nav">Sobre mi</Link>
                <br />
                <Link smooth={true} to="services" offset={-80} className="footer-nav">Servicios</Link>
                <br />
                <Link smooth={true} to="skill" offset={-80} className="footer-nav">Habilidades</Link>
              </div>
              <div className="col">
                <Link smooth={true} to="experiencie" offset={-100} className="footer-nav">Mis logros</Link>
                <br />
                <Link smooth={true} to="méritos" offset={-100} className="nav-link"  className="footer-nav">Méritos</Link>
                <br />
                <Link smooth={true} to="portafolio" offset={-100} className="nav-link"  className="footer-nav">Portafolio</Link>
                <br />
                <Link smooth={true} to="contact" offset={-100} className="footer-nav">Contacto</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-6 align-items-center">
            <div className="d-flex justify-content-center">
              <FacebookShareButton 
                url={"https://portafolio-rm.netlify.app"}
                quote={"FullStack Developer"}
                hashtag="#javascript_React"
              >
                <FacebookIcon borderRadius={50}  className="mx-3" size={36} />
              </FacebookShareButton>
              <TwitterShareButton
                url={"https://portafolio-rm.netlify.app"}
                quote={"FullStack Developer"}
                hashtag="#javascript_React"
              >
                <TwitterIcon borderRadius={50}  className="mx-3" size={36} />
              </TwitterShareButton>
              
              <LinkedinShareButton
                url={"https://portafolio-rm.netlify.app"}
                quote={"FullStack Developer"}
                hashtag="#javascript_React"
              >
                <LinkedinIcon borderRadius={50}  className="mx-3" size={36} />
              </LinkedinShareButton>

              <TelegramShareButton
              url={"https://portafolio-rm.netlify.app"}
                quote={"FullStack Developer"}
                hashtag="#javascript_React">
                  <TelegramIcon  borderRadius={50}  className="mx-3" size={36} />
              </TelegramShareButton>

            </div>
            <p className="pt-3 text-center">
              Copyright&copy;
              {new Date().getFullYear()}&nbsp;Rafael Martínez
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;